import {
    ADD_NEWPRODUCT_FAILED,
    ADD_NEWPRODUCT_LOADING,
    ADD_NEWPRODUCT_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addNewProductReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case ADD_NEWPRODUCT_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_NEWPRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_NEWPRODUCT_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




